import { API_AUTH_SUCCESS } from '../../constants/API';
import initialState from "./initialState";
import {AlertAction, AlertState} from "./types";
import {
    ALERTS_SET_CURRENT_CAMERA,
    ALERTS_SET_EVENTS,
    ALERTS_SET_SELECTED_CAMERA,
    ALERTS_SET_SORTING_EVENTS,
    ALERTS_SET_ALARM_SCENARIO
} from "./constants";
import {sortEvents} from "../../utils";


const reducer = (state: AlertState = initialState, action: AlertAction) => {

    switch(action.type) {

        case ALERTS_SET_EVENTS : {
            const events = action.events ? action.events : state.events;
            const { type, direction } = state.sorting;
            const sortedEvents = sortEvents(events, direction, type);

            return {
                ...state,
                transactionId: action.transactionId ? action.transactionId : state.transactionId,
                playSound: action.playSound,
                events: sortedEvents,
                initialLoad: false
            };
        }

        case ALERTS_SET_SORTING_EVENTS : {
            const { type, direction } = action.sorting;
            const sortedEvents = sortEvents(state.events, direction, type);

            return {
                ...state,
                events: sortedEvents,
                sorting: {
                    type: type,
                    direction: direction
                }
            };

        }

        case ALERTS_SET_SELECTED_CAMERA : return ({
            ...state,
            selectedEvent: action.event
        });

        case ALERTS_SET_CURRENT_CAMERA : return ({
            ...state,
            currentCamera: action.camera
        });

        case ALERTS_SET_ALARM_SCENARIO : return ({
            ...state,
            alarmScenarioList: action.scenarioList
        });

        case API_AUTH_SUCCESS : return {
            ...state,
            initialLoad: true,
            playSound: false
        }

        //
        case('@@router/LOCATION_CHANGE'): return {
            ...state,
            selectedEvent: null
        };

        default: return {...state}
    }
};

export default reducer